import siFetch from "api/fetch";

import handleParams from "api/handle-params";

const commissionRecord = (params, init = null) =>
  siFetch(`/api/v1/revenue/record${handleParams(params)}`, init);

export default commissionRecord;
